module.exports = __webpack_public_path__ + "static/media/student attendance.63ff630b.svg";